import {Industries} from '../../../Components/Industries';
const IndustryButton = ({industry, selected, ...props}) =>{
    let _selectedIndustry = Industries.find(t => t.id === industry);
    if(!_selectedIndustry)
        return null;
    return selected ? _selectedIndustry.selected(props) : _selectedIndustry.resting(props);
}
export default IndustryButton;